import { ExcludedCascoPackagesEnum } from '@crm/api'
import { useLocales } from '@shared/locales'
import { Col, Form, InputNumber, Select } from 'antd'
import { useMemo } from 'react'

/**
 * The CASCO cross-sell selection criteria.
 *
 * Renders bare columns so the fields flow in the campaign form's own grid,
 * continuing the row the campaign settings start — hence no Row of its own.
 * Names are nested under `criteria` to match the shape the campaign is saved
 * with, which also keeps them from colliding with the campaign's own fields.
 */
export const CascoCriteriaFields = () => {
  const { t } = useLocales()

  const packageOptions = useMemo(
    () =>
      Object.values(ExcludedCascoPackagesEnum).map((value) => ({
        label: t(`lead_generation.${value}`, value),
        value
      })),
    [t]
  )

  return (
    <>
      {/* Takes the left half of its row: it holds a tag per excluded package,
          which would wrap immediately in a quarter-row. */}
      <Col span={24} xl={12}>
        <Form.Item
          name={['criteria', 'excluded_casco_packages']}
          label={t('lead_generation.excluded_casco_packages')}
          extra={t('lead_generation.excluded_packages_hint')}
        >
          <Select mode="multiple" allowClear options={packageOptions} />
        </Form.Item>
      </Col>

      <Col span={24} sm={12} xl={6}>
        <Form.Item
          name={['criteria', 'issued_window_days']}
          label={t('lead_generation.issued_window_days')}
        >
          <InputNumber min={1} className="w-full" />
        </Form.Item>
      </Col>

      <Col span={24} sm={12} xl={6}>
        <Form.Item
          name={['criteria', 'max_vehicle_age_years']}
          label={t('lead_generation.max_vehicle_age_years')}
        >
          <InputNumber min={0} className="w-full" />
        </Form.Item>
      </Col>
    </>
  )
}
